import { z } from 'zod';

// Schema for Vehicle Identity (VIG v2.2)
export const VehicleIdentitySchema = z.object({
    identity_id: z.string(),
    vin: z.string().nullable(),
    vin_checksum_valid: z.boolean(),
    make: z.string(),
    model: z.string(),
    year: z.number().min(1900).max(2035),
    engine: z.string(),
    engine_swap_confirmed: z.boolean(),
    market: z.enum(['GCC', 'Africa', 'Europe', 'Japan', 'USA', 'Other']),
    confidence: z.enum(['High', 'Medium', 'Low']),
    confidence_score: z.number().min(0).max(1),
    sources: z.array(z.string()),
    conflicts: z.array(z.string()),
    notes: z.string(),
    validated_at: z.string().nullable(),
    last_activity_at: z.string(),
    user_confirmed: z.boolean()
});

// Schema for Customer Report View
export const CustomerReportSchema = z.object({
    title: z.string().default("غير معروف"),
    confidence: z.enum(["high", "medium", "low"]).default("medium"),
    explanation: z.string().default("لا يوجد تفاصيل إضافية"),
    practical_fix: z.string().default(""),
    osta_advice: z.string().default(""),
});

// Schema for Technician Guide View
export const TechnicalGuideSchema = z.object({
    fault_category: z.enum(["engine", "transmission", "suspension", "electrical", "cooling", "brakes", "other"]).default("other"),
    part_numbers: z.array(z.string()).default([]),
    required_tools: z.array(z.string()).default([]),
    technical_steps: z.array(z.string()).default([]),
    diagram_label: z.string().default("مخطط المحرك العام"),
    diagram_explanation: z.string().default(""),
});

// Schema for Diagram Hotspots (Phase 2.2)
export const HotspotSchema = z.object({
    id: z.string(),
    x: z.number(),
    y: z.number(),
    label: z.string(),
    explanation_ar: z.string(),
    part_number: z.string().optional(),
});

// Main Phase 4.1 Response Schema
export const DiagnosisSchema = z.object({
    Is_FollowUp: z.boolean().default(false),
    FollowUp_Question: z.string().nullable().default(null),
    customerReport: CustomerReportSchema.optional().nullable(),
    technicalGuide: TechnicalGuideSchema.optional().nullable(),
    risk_level: z.enum(["low", "medium", "high"]).default("low"),
    vehicle_identity: VehicleIdentitySchema.optional().nullable(),
    hotspots: z.array(HotspotSchema).optional().default([]),
});

export type VehicleIdentity = z.infer<typeof VehicleIdentitySchema>;
export type DiagnosisData = z.infer<typeof DiagnosisSchema>;
export type CustomerReport = z.infer<typeof CustomerReportSchema>;
export type TechnicalGuide = z.infer<typeof TechnicalGuideSchema>;

